<template>
    <article>
        <p>
            The <a href="https://www.splunk.com/en_us/blog/learn/red-monitoring.html" target="_blank">RED</a> (Rate, Errors, Duration) method
            is a popular approach to instrument and troubleshoot microservices applications.
            In Coroot - Open Source observability platform - we have designed an effective interface
            allowing to use RED method with Distributed Tracing and OpenTelemetry (OTEL) generated data.
        </p>

        <h2>Let's start from the system's overview</h2>

        <v-card class="pa-5 my-6">
            <v-img eager src="/static/img/blog/new-tracing/coroot_overview.png" />
        </v-card>

        <p>
            This summary gives us everything you need to apply RED method
            to the application - we can see the system is handling roughly 70 requests per second with p99 latency below 250ms and no errors.
        </p>


        <h2>Errors</h2>

        <v-card class="pa-5 my-6">
            <v-img eager src="/static/img/blog/new-tracing/coroot_errors_overview.png" />
        </v-card>

        <p>
            What if there are errors?
            You can clearly see errors in the overview interface - about 5 errors/sec in this case.
            What is causing them?
            Select the relevant range on the graph to find the causes - Coroot automatically analyzes all affected requests and pinpoints spans where errors are originated.
        </p>

        <v-card class="pa-5 my-6">
            <v-img eager src="/static/img/blog/new-tracing/coroot_error_reasons.png" />
        </v-card>

        <p>Want to double check if this is indeed the case? You can click on the “Sample Trace”:</p>

        <v-card class="pa-5 my-6">
            <v-img eager src="/static/img/blog/new-tracing/coroot_error_trace.png" />
        </v-card>

        <h2>Compare and Contrast</h2>

        <p>
            Another thing which is very helpful to understand Why Errors or high latency is happening
            is to be able to compare and contrast the difference between the normal baseline
            and when errors are happening - Coroot allows you to do just that with its “Compare Attributes” feature:
        </p>


        <v-card class="pa-5 my-6">
            <v-img eager src="/static/img/blog/new-tracing/coroot_attributes_comparison.png" />
        </v-card>


        <h2>Latency Outliers</h2>

        <p>
            Another kind of issue we often diagnose with RED method is slow requests or in other words latency outliers.
            With “Latency Explorer” Coroot analyzes all the traces to highlight where specifically elevated latency comes from:
        </p>

        <v-card class="pa-5 my-6">
            <v-img eager src="/static/img/blog/new-tracing/coroot_latency_explorer.png" />
        </v-card>

        <p>
            Coroot visualizes latency as Flamegraph
            where wider frames means higher contribution to the latency and operations highlighted in red
            in comparison mode are taking more time than before.
            This makes it very easy to pinpoint where specifically the increased latency is coming from.
        </p>


        <h2>Conclusion</h2>

        <p>
            Coroot makes distributed tracing easy, allowing you to diagnose the most common issues,
            enabled by OpenTelemetry Traces in just a couple of clicks.
            It also can do much more. Check out the <router-link :to="{name: 'features'}">Coroot Overview</router-link> for details.
        </p>

        <p>
            Try <router-link :to="{name: 'cloud'}">Coroot Cloud</router-link> now (14-day free trial is available) or follow the instructions on our <router-link :to="{name: 'docs', params: {chapter: 'coroot-community-edition', group: 'getting-started', item: 'installation'}}">Getting started</router-link> page to install Coroot Community Edition.
        </p>
        <p>
            If you like Coroot, give us a ⭐ on <a href="https://github.com/coroot/coroot" target="_blank">GitHub</a>️ –
            it helps us reach more engineers and improve our product for you.
        </p>
        <p>Any questions or feedback? Reach out to us on <a href="https://join.slack.com/t/coroot-community/shared_invite/zt-1gsnfo0wj-I~Zvtx5CAAb8vr~r~vecyw" target="_blank"><v-icon>mdi-slack</v-icon>Slack</a>.</p>
    </article>
</template>

<script>


export default {
    components: {},
    data() {
        return {
            installation: null,
        };
    },
}
</script>

<style scoped>
</style>
